import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Inject,
  NgModule,
  NgZone,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { OeAppService } from '../../shared/oe-app.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { SafeUrlPipeModule } from '../../pipes/safe-url.pipe';
import { CommonExpressionsEventType } from '../../shared/types/common-expressions-events.enum';
import { ImmersionCourseService } from '../../shared/immersion-course.service';
import { CourseContentType } from '../../shared/types/course-content-type';
import { GenericModalService } from '../../shared/generic-modal/generic-modal.service';
import { MODAL_DATA } from '../../shared/tokens/modal-data.token';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { TranslatePipe, TranslatePipeModule } from '../../shared/translate.pipe';
import { UserwaySyncModule } from '../../shared/userway-sync.directive';
import { IframeActivityModalBase } from '../../shared/iframe-activity-modal/iframe-activity-modal.base';
import { IframeActivityModalData } from '../../shared/iframe-activity-modal/iframe-activity-modal-data';

export const COMMON_EXPRESSIONS_MODAL_TITLE_ID = 'common-expressions-modal-title';

@Component({
  selector: 'lp2-common-expressions-modal',
  styleUrls: ['./common-expressions-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <h2 id="${COMMON_EXPRESSIONS_MODAL_TITLE_ID}" class="sr-only">{{ 'studybundle.idioms.title' | translate }}</h2>
    <iframe
      #iframe
      [lp2UserwaySync]="targetOrigin"
      *ngIf="url$ | async as url"
      [src]="url | safeUrl"
      frameborder="0"
      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
      allow="autoplay; fullscreen"
      [height]="height"
      [attr.title]="'studybundle.idioms.title' | translate"
      class="common-expressions-modal-iframe"
      data-test-id="common-expressions-modal-iframe"
    >
    </iframe>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonExpressionsModalComponent extends IframeActivityModalBase {
  @HostBinding('class.common-expressions-modal') readonly hostClass = true;
  @ViewChild('iframe') iframe: ElementRef<HTMLIFrameElement>;
  protected readonly closeEventType = CommonExpressionsEventType.COMMON_EXPRESSIONS_CLOSE_EVENT;
  protected readonly heightEventType = CommonExpressionsEventType.COMMON_EXPRESSIONS_HEIGHT_EVENT;
  protected readonly reportActivityProgressEventType =
    CommonExpressionsEventType.COMMON_EXPRESSIONS_REPORT_ACTIVITY_PROGRESS_EVENT;
  protected readonly courseContentType = CourseContentType.IDIOMS;

  constructor(
    private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    activeModal: NgbActiveModal,
    cdRef: ChangeDetectorRef,
    ngZone: NgZone,
    immersionCourseService: ImmersionCourseService,
    genericModalService: GenericModalService,
    translatePipe: TranslatePipe,
    @Inject(MODAL_DATA) modalData: IframeActivityModalData
  ) {
    super(activeModal, cdRef, ngZone, immersionCourseService, genericModalService, translatePipe, modalData);
  }

  protected getHost(): string {
    return this.oeApp.webCommonExpressionsHost;
  }

  protected buildUrl(): string {
    return `${this.oeApp.webCommonExpressionsHost}?env=${encodeURIComponent(
      this.oeApp.environment
    )}&url=${encodeURIComponent(this.modalData.item.url)}&lang=${encodeURIComponent(
      this.oeAppPersonService.preferredLang
    )}`;
  }
}

@NgModule({
  imports: [CommonModule, TranslatePipeModule, SafeUrlPipeModule, UserwaySyncModule],
  declarations: [CommonExpressionsModalComponent],
  entryComponents: [CommonExpressionsModalComponent],
  exports: [CommonExpressionsModalComponent],
})
export class CommonExpressionsModalModule {}



// WEBPACK FOOTER //
// ./ts/app/home/common-expressions-modal/common-expressions-modal.component.ts